var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Button, Drawer, DrawerHeader, DrawerContent, DrawerActions, } from '@petsly/shared-client';
import * as yup from 'yup';
import { useFormik } from 'formik';
import slugify from 'slugify';
import { useDrawer } from 'context/DrawerContext';
import translations from 'translations/shared';
import DescriptionField from './components/Description';
import NameField from './components/Name';
import EventDatesField from './components/EventDates';
import LimitField from './components/Limit';
import PaidField from './components/Paid';
import PriceField from './components/Price';
var View = function (_a) {
    var isProcessing = _a.isProcessing, onCreateState = _a.onCreateState, onCreateSessionState = _a.onCreateSessionState;
    var formatMessage = useIntl().formatMessage;
    var closeDrawer = useDrawer().closeDrawer;
    var validationSchema = useMemo(function () {
        return yup.object().shape({
            title: yup.string().required(formatMessage(translations.required)),
            description: yup.string().nullable(),
            limit: yup.number().required(formatMessage(translations.required)),
            paid: yup.boolean().required(formatMessage(translations.required)),
            price: yup.number().required(formatMessage(translations.required)),
            estimatedStartedAt: yup
                .date()
                .required(formatMessage(translations.required)),
        });
    }, []);
    var initialValues = {
        title: '',
        description: '',
        paid: false,
        price: 0,
        limit: 0,
        estimatedStartedAt: undefined,
    };
    var formik = useFormik({
        validationSchema: validationSchema,
        initialValues: initialValues,
        onSubmit: function (values) {
            var estimatedStartedAt = values.estimatedStartedAt;
            var webinar = {
                title: values.title,
                description: values.description,
                paid: values.paid === 'true',
                price: parseInt(values.price),
                limit: parseInt(values.limit),
                slug: slugify(values.title),
            };
            onCreateState(webinar);
            onCreateSessionState({ estimatedStartedAt: estimatedStartedAt });
        },
    });
    var setFieldValue = formik.setFieldValue, setValues = formik.setValues, setFieldTouched = formik.setFieldTouched, submitForm = formik.submitForm, values = formik.values, errors = formik.errors, touched = formik.touched;
    return (_jsxs(Drawer, __assign({ open: true, onDismiss: function () {
            closeDrawer();
        } }, { children: [_jsx(DrawerHeader, __assign({ onClose: closeDrawer }, { children: formatMessage(translations.newWebinar) }), void 0), _jsxs(DrawerContent, { children: [_jsx(NameField, { value: values.title, touched: touched.title, error: errors.title, onBlur: function () { return setFieldTouched('title'); }, onChange: function (value) { return setFieldValue('title', value); } }, void 0), _jsx(DescriptionField, { value: values.description, touched: touched.description, error: errors.description, onBlur: function () { return setFieldTouched('description'); }, onChange: function (value) { return setFieldValue('description', value); } }, void 0), _jsx(EventDatesField, { values: {
                            value: values.estimatedStartedAt,
                        }, errors: {
                            value: errors.estimatedStartedAt,
                        }, touched: {
                            value: touched.estimatedStartedAt,
                        }, onChange: function (key, value) { return setFieldValue(key, value); }, onBlur: function (key) { return setFieldTouched(key); } }, void 0), _jsx(LimitField, { value: values.limit, touched: touched.limit, error: errors.limit, onBlur: function () { return setFieldTouched('limit'); }, onChange: function (value) { return setFieldValue('limit', value); } }, void 0), _jsx(PaidField, { value: values.paid, error: errors.paid, touched: touched.paid, onChange: function (value) { return setFieldValue('paid', value); }, onBlur: function () { return setFieldTouched('paid'); } }, void 0), _jsx(PriceField, { value: values.price, touched: touched.price, error: errors.price, onBlur: function () { return setFieldTouched('price'); }, onChange: function (value) { return setFieldValue('price', value); } }, void 0)] }, void 0), _jsx(DrawerActions, { children: _jsx(Button, __assign({ onClick: submitForm, disabled: isProcessing, fullWidth: true }, { children: formatMessage(translations.save) }), void 0) }, void 0)] }), void 0));
};
export default View;
